import { environmentDev } from './environment-dev'
import { environmentProd } from './environment-prod'
import { IEnvironmentFromFile } from './environment.types'

export const environment: IEnvironmentFromFile =
  process.env['STAGE_NAME'] === 'production' ? environmentProd : environmentDev
